// Port of api/fuel/app/classes/insights/worth/summary.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function parseGamesIndex(value) {
	if (!value) return []
	try {
		var parsed = JSON.parse(value)
		if (Array.isArray(parsed)) return parsed.map(function(id) { return parseInt(id, 10) }).filter(Boolean)
		if (parsed && Array.isArray(parsed.games)) return parsed.games.map(function(id) { return parseInt(id, 10) }).filter(Boolean)
		if (parsed && Array.isArray(parsed.index)) return parsed.index.map(function(id) { return parseInt(id, 10) }).filter(Boolean)
	} catch (e) {
		// Fall through to legacy comma-separated parsing.
	}
	return String(value).split(',').map(function(id) { return parseInt(id, 10) }).filter(Boolean)
}

function monthStartOffset(monthOffset) {
	var date = new Date()
	date.setUTCDate(1)
	date.setUTCHours(0, 0, 0, 0)
	date.setUTCMonth(date.getUTCMonth() + monthOffset)
	return Math.floor(date.getTime() / 1000)
}

function monthStampOffset(monthOffset) {
	var date = new Date(monthStartOffset(monthOffset) * 1000)
	var month = String(date.getUTCMonth() + 1)
	if (month.length < 2) month = '0' + month
	var year = String(date.getUTCFullYear()).slice(-2)
	return month + '.' + year
}

function uniqueIntersection(a, b) {
	var lookup = {}
	var out = []
	for (var i = 0; i < b.length; i++) lookup[parseInt(b[i], 10)] = true
	for (var j = 0; j < a.length; j++) {
		var value = parseInt(a[j], 10)
		if (value && lookup[value] && out.indexOf(value) === -1) out.push(value)
	}
	return out
}

export default Segment.extend({
	name: 'summary',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: false,
	run: function(type, owner) {
		var summary = {
			total: {
				current: 0,
				one: 0,
				six: 0,
				twelve: 0
			},
			like: {
				one: 0,
				six: 0,
				twelve: 0
			}
		}

		var currentRows = Util.queryFast(
			'SELECT * FROM insight_user_collection WHERE user_id = ' + owner.get_id() + ' ORDER BY insight_date DESC LIMIT 1'
		)
		var currentInsight = currentRows.length ? currentRows[0] : null

		if (!currentInsight) return { summary: summary }

		var total = parseFloat(currentInsight.insight_value) || 0
		var currentGames = parseGamesIndex(currentInsight.insight_games)
		var periods = { one: 1, six: 6, twelve: 12 }
		var totalKeys = Object.keys(periods)
		var targetDates = []
		var targetStamps = []

		summary.total.current = Math.round(total)

		for (var periodIndex = 0; periodIndex < totalKeys.length; periodIndex++) {
			var periodKey = totalKeys[periodIndex]
			targetDates.push(monthStartOffset(0 - periods[periodKey]))
			targetStamps.push(monthStampOffset(0 - periods[periodKey]))
		}

		var priorInsights = Util.queryFast(
			'SELECT insight_date, insight_stamp, insight_value, insight_games' +
			' FROM insight_user_collection' +
			' WHERE user_id = ' + owner.get_id() +
			' AND (' +
				'insight_date IN(' + Util.in(targetDates) + ')' +
				' OR insight_stamp IN(' + Util.in(targetStamps) + ')' +
			')'
		)
		var insightsByDate = {}
		var insightsByStamp = {}
		for (var pi = 0; pi < priorInsights.length; pi++) {
			var priorInsight = priorInsights[pi]
			insightsByDate[parseInt(priorInsight.insight_date, 10)] = priorInsight
			insightsByStamp[String(priorInsight.insight_stamp)] = priorInsight
		}

		for (var i = 0; i < totalKeys.length; i++) {
			var key = totalKeys[i]
			var totalInsight = insightsByDate[monthStartOffset(0 - periods[key])]
			summary.total[key] = totalInsight ? Math.round(total - (parseFloat(totalInsight.insight_value) || 0)) : null
		}

		var intersectionsByKey = {}
		var unionGameIds = {}
		var unionVersionIds = {}
		for (var j = 0; j < totalKeys.length; j++) {
			var periodKey = totalKeys[j]
			var stamp = monthStampOffset(0 - periods[periodKey])
			var stampInsight = insightsByStamp[stamp]

			if (!stampInsight || !stampInsight.insight_games) {
				summary.like[periodKey] = null
				continue
			}

			var intersect = uniqueIntersection(currentGames, parseGamesIndex(stampInsight.insight_games))
			intersectionsByKey[periodKey] = intersect
			if (!intersect.length) {
				summary.like[periodKey] = 0
				continue
			}
			for (var ig = 0; ig < intersect.length; ig++) unionGameIds[intersect[ig]] = true
		}

		var unionGameIdList = Object.keys(unionGameIds).map(function(id) { return parseInt(id, 10) }).filter(Boolean)
		var collectionByGame = {}
		if (unionGameIdList.length) {
			var collectionRows = Util.queryFast(
				'SELECT game_id, game_version_id, collection_value FROM collection WHERE user_id = ' + owner.get_id() +
				' AND game_id IN(' + Util.in(unionGameIdList) + ')'
			)
			for (var c = 0; c < collectionRows.length; c++) {
				var collectionRow = collectionRows[c]
				var collectionGameId = parseInt(collectionRow.game_id, 10)
				if (!collectionGameId) continue
				collectionByGame[collectionGameId] = collectionRow
				var collectionVersionId = parseInt(collectionRow.game_version_id, 10) || 0
				if (collectionVersionId) unionVersionIds[collectionVersionId] = true
			}
		}

		var unionVersionIdList = Object.keys(unionVersionIds).map(function(id) { return parseInt(id, 10) }).filter(Boolean)
		var valueVersionByStamp = {}
		if (unionVersionIdList.length) {
			var versionRows = Util.queryFast(
				'SELECT game_version_id, insight_value, insight_stamp FROM insight_game_version_value' +
				' WHERE game_version_id IN(' + Util.in(unionVersionIdList) + ')' +
				' AND insight_stamp IN(' + Util.in(targetStamps) + ')'
			)
			for (var v = 0; v < versionRows.length; v++) {
				var versionRow = versionRows[v]
				var versionStamp = String(versionRow.insight_stamp)
				if (!valueVersionByStamp[versionStamp]) valueVersionByStamp[versionStamp] = {}
				valueVersionByStamp[versionStamp][parseInt(versionRow.game_version_id, 10)] = parseFloat(versionRow.insight_value) || 0
			}
		}

		var valueGameByStamp = {}
		if (unionGameIdList.length) {
			var gameRows = Util.queryFast(
				'SELECT game_id, insight_value, insight_stamp FROM insight_game_value WHERE game_id IN(' + Util.in(unionGameIdList) + ')' +
				' AND insight_stamp IN(' + Util.in(targetStamps) + ')'
			)
			for (var g = 0; g < gameRows.length; g++) {
				var gameRow = gameRows[g]
				var gameStamp = String(gameRow.insight_stamp)
				if (!valueGameByStamp[gameStamp]) valueGameByStamp[gameStamp] = {}
				valueGameByStamp[gameStamp][parseInt(gameRow.game_id, 10)] = parseFloat(gameRow.insight_value) || 0
			}
		}

		for (var k = 0; k < totalKeys.length; k++) {
			var likeKey = totalKeys[k]
			if (summary.like[likeKey] === null) continue
			var likeStamp = monthStampOffset(0 - periods[likeKey])
			var intersectGames = intersectionsByKey[likeKey] || []
			if (!intersectGames.length) continue
			var valueVersion = valueVersionByStamp[likeStamp] || {}
			var valueGame = valueGameByStamp[likeStamp] || {}

			var likeNow = 0
			var likeThen = 0

			for (var r = 0; r < intersectGames.length; r++) {
				var gameId = intersectGames[r]
				var row = collectionByGame[gameId]
				if (!row) continue
				var version = parseInt(row.game_version_id, 10) || 0
				var currentValue = parseFloat(row.collection_value) || 0
				var versionValue = version ? valueVersion[version] : null
				var gameValue = valueGame[gameId]
				var thenValue = currentValue

				// Match PHP: a missing OR zero historical value falls back to the
				// current collection value instead of contributing zero.
				if (versionValue) {
					thenValue = versionValue
				} else if (gameValue) {
					thenValue = gameValue
				}

				likeNow += currentValue
				likeThen += thenValue
			}

			summary.like[likeKey] = Math.round(likeNow - likeThen)
		}

		return {
			summary: summary
		}
	}
})
